import { Box, Grid, Paper, Typography } from '@mui/material';

import React from 'react';
import {
  AppFormikCheckbox,
  AppFormikCheckboxGroup,
  AppFormikTextArea,
} from 'shared/components/AppComponents';

const CapabilityAndFunctionsProfile: React.FC<any> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { purpose } = props;
  console.log(purpose);
  return (
    <Box className="paper-form-content">
      <Paper variant="outlined">
        <Typography variant="h6">Capability & Function Profile</Typography>
        <Box className="paper-form-input-content">
          <Grid spacing={4} container className="paper-form-label-input-grid">
            <Grid item xs={12}>
              <AppFormikTextArea
                name="business_tasks_enabled"
                placeholder="Enter business tasks enabled"
                label="Business Tasks Enabled"
                outerLabel
                rows={3}
                inputProps={{
                  style: { resize: 'vertical' },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <AppFormikTextArea
                name="connected_enterprise_systems"
                placeholder="Enter connected enterprise systems"
                label="Connected Enterprise Systems"
                outerLabel
                rows={3}
                inputProps={{
                  style: { resize: 'vertical' },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <AppFormikTextArea
                name="data_sources_accessed"
                placeholder="Enter data sources accessed"
                label="Data Sources Accessed"
                outerLabel
                rows={3}
                inputProps={{
                  style: { resize: 'vertical' },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Box>
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                  mb={2}
                >
                  Action Supported
                </Typography>
                <AppFormikCheckboxGroup
                  name="actions_supported"
                  outerLabel=""
                  options={[
                    { label: 'read', value: 'read' },
                    { label: 'write', value: 'write' },
                    { label: 'delete', value: 'delete' },
                    { label: 'execute', value: 'execute' },
                    { label: 'admin', value: 'admin' },
                    { label: 'external calls', value: 'external calls' },
                  ]}
                  row
                  sx={{
                    width: 'auto',
                  }}
                  customGridStyle={{
                    flexWrap: 'nowrap',
                  }}
                />
              </Box>
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikCheckbox
                name="can_trigger_side_effects"
                label="Can Trigger Side Effects"
                outerLabel=""
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikCheckbox
                name="supports_agentic_workflows"
                label="Supports Agentic Workflows"
                outerLabel=""
              />
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export default CapabilityAndFunctionsProfile;
